import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS, TYPE_IROPS } from '@app/enums/irops.enum';
import { Airports } from '@app/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'title-irops-rebrand',
    templateUrl: './title-irops-rebrand.component.html',
    styleUrls: ['./title-irops-rebrand.component.scss'],
    standalone: false
})
export class TitleIropsRebrandComponent implements OnInit {
  typeIrops = IROPS_STATUS;

  @Input() caseTitle = this.typeIrops.DELAYED;
  @Input() destination = '';

  cityName = '';

  constructor(private _translateService: TranslateService) { }

  ngOnInit() {
    const city = Airports.findAriportByCode(this.destination);
    const lang = this._translateService?.currentLang.replace('-', '_');
    this.cityName = city[lang];
  }

}
